export const JsonParse = <ReturnType>(content: string) => {
  try {
    return JSON.parse(content) as ReturnType;
  } catch {
    return null;
  }
};
